import React from 'react';
import { Route, Switch } from 'react-router';

import Tutor from './Tutor';
import Tutors from './Tutors';
import TutorApproval from './TutorApproval';

export default (
  <Route key="admin-tutor" path="/admin/tutor">
    <Switch>
      <Route path="/admin/tutor/" exact title="Tutors" component={Tutors} />
      <Route
        path="/admin/tutor/:nodeId"
        exact
        title="Tutor"
        component={Tutor}
      />
      <Route
        path="/admin/tutor/:nodeId/approve"
        title="Approve"
        exact
        component={TutorApproval}
      />
    </Switch>
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/TutorRoutes.js